import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  // base: '/',
  routes: [
    { // 分为平台架构和教材架构
      path: '/',
      name: 'layout',
      redirect: '/plat',
      component: () => import('@/layout/index.vue'),
      children: [{
        path: '/plat',
        name: 'platLayout',
        redirect: '/plat/login',
        component: () => import('@/layout/plat.vue'),
        children: [{
          path: '/plat/login',
          name: 'login',
          component: () => import('@/views/plat/login.vue')
        }, {
          path: '/plat/bookList',
          name: 'bookList',
          component: () => import('@/views/plat/bookList.vue')
        }]
      }, {
        path: '/book',
        name: 'bookLayout',
        component: () => import('@/layout/book.vue'),
        redirect: '/book/experiment',
        children: [
          { // 教材模式
            path: '/book/normal',
            name: 'index',
            component: () => import('@/views/book/normal.vue')
          },
          { // 实验模式
            path: '/book/experiment',
            name: 'index',
            component: () => import('@/views/book/experiment.vue')
          }
        ]
      }]
    },
    {
      path: '/fullVideo',
      name: 'fullVideo',
      component: () => import('@/components/fullScreenVideo.vue')
    },
    {
      path: '/fullURL',
      name: 'fullURL',
      component: () => import('@/components/fullScreenURL.vue')
    },
    {
      path: '/fullGraph',
      name: 'fullGraph',
      component: () => import('@/components/knowledgeGraphFullScreen.vue')
    },
    {
      path: '/mind',
      name: 'mind',
      component: () => import('@/views/myMind.vue')
    },
    {
      path: '/fullX6',
      name: 'fullX6',
      component: () => import('@/components/x6FullScreen.vue')
    },
    {
      path: '/virtual',
      name: 'virtual',
      component: () => import('@/components/virtual.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js